import PostcodeService from './services/postcodeService'

const $input = $('#register-post-code, .autocomplete-address')

const setData = ($ele, data) => {
  $ele.val(data)
  $ele.trigger('change')
}

$('.postcode-submit').remove()
$('#register-place').prop('disabled', true)

var timer

$('#register-post-code').on('input', function (e) {
  if (PostcodeService.isValidPostcode($('#register-post-code')[0].value)) {
    clearTimeout(timer)
    timer = setTimeout(function () {
      const $this = $(e.currentTarget)
      $this.attr('disabled', true)
      const postcode = $input.val()

      PostcodeService.searchPostcode(postcode)
        .then((response) => {
          if (response && response.length > 0) {
            const address = response[0]

            const $form = $this.closest('form')
            const $address1 = $form.find('#register-place')
            const $address2 = $form.find('#register-city')
            const $address3 = $form.find('#register-address')

            setData($address1, address.address1)
            setData($address2, address.address2)
            setData($address3, address.address3)
            $('#register-prefecture').val(
              'JP-' + ('0' + address.prefcode).slice(-2)
            )
            $('#register-country').val('JP')
          } else {
            $input.css('border', '1px solid red')
            $('#register-place').val('')
            $('#register-city').val('')
            $('#register-address').val('')
            $('#register-post-code').val('')
            $('#register-number').val('')
            $('#register-prefecture').val('')
            $('#register-country').val('')
            alert(
              '郵便番号から住所を見つけることができませんでした。入力内容をご確認ください。'
            )
            setTimeout(() => {
              $input.css('border', '1px solid black')
            }, 3000)
          }

          $this.attr('disabled', false)
        })
        .catch((e) => {
          $this.attr('disabled', false)
          $('#register-place').val('')
          $('#register-city').val('')
          $('#register-address').val('')
          $('#register-post-code').val('')
          $('#register-number').val('')
          $('#register-prefecture').val('')
          $('#register-country').val('')
          alert(
            '申し訳ございませんが、郵便番号の検索中にエラーが発生しました。しばらくしてからもう一度お試しください。'
          )
          console.error(e)
        })
    }, 100)
  }
})
